import { observer } from "mobx-react";
//TODO: Extract bar into here
//TODO: create props like ratio/percentage/proportion, name
//TODO: If ratio is undefined, null or negative, then display "insufficient data" or sth
//TODO: Create ennumerator or function to determine Average, Weak, Good etc based on percentage.

interface ILangCompStatsBar {
  proportion?: number;
  title?: string;
}

type ProficiencyLevel = "Weak" | "Average" | "Good" | "Strong";

function getProficiencyLevel(percentage?: number) {
  if (!percentage) return "N/A";
  if (percentage <= 40) return "Weak";
  if (percentage <= 60) return "Average";
  if (percentage <= 85) return "Good";
  if (percentage <= 100) return "Strong";
}

export default observer(LangCompStatsBar);
function LangCompStatsBar({ proportion, title }: ILangCompStatsBar) {
  const roundedPercentage =
    proportion && proportion >= 0 ? Math.round(proportion * 100) : undefined;
  const proficiencyLevel = getProficiencyLevel(roundedPercentage);
  return (
    <>
      <div className="w-full h-16 flex flex-row gap-2 items-center">
        <p className="text-lg font-normal w-[20%] text-center">{title}</p>
        <div className="relative flex-1 w-full h-full p-2">
          <div className="relative h-full rounded-md w-full bg-brij-Grey">
            {roundedPercentage ? (
              <div
                className={`absolute top-0 bottom-0 rounded-md h-full bg-brij-Yellow z-20`}
                style={{
                  width: roundedPercentage + "%",
                }}
              />
            ) : (
              <div className="h-full w-full text-center z-20 flex justify-center items-center text-brij-White">
                Insufficient Data
              </div>
            )}
          </div>
        </div>
        <p className="text-lg font-normal w-[20%] text-center">
          {proficiencyLevel}
        </p>
      </div>
    </>
  );
}
